export enum VaultTimeoutAction {
  Lock = "lock",
  LogOut = "logOut",
}
